import * as React from 'react';
import { useDispatch } from 'react-redux';
import { fetchApi, makeResetCache, notifyError, notifyResponse, Editable } from 'gossamer-front-end';
import { AdminEmailAddressUpdateRequest, User, UserView } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType, validateEmailAddress } from 'gossamer-unified';

export interface ChangeEmailAddressButtonProps {
  userId: string;
}

export const ChangeEmailAddressButton = (props: ChangeEmailAddressButtonProps) => {
  const [newEmailAddress, setNewEmailAddress] = React.useState<string | null>(null);
  const isValid = !!newEmailAddress && validateEmailAddress(newEmailAddress) === null;
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);

  const handleClick = async () => {
    try {
      const payload: AdminEmailAddressUpdateRequest = {
        userId: props.userId,
        newEmailAddress: newEmailAddress,
      };
      const response = await fetchApi('POST', `/main/admin-update-user-email-address`, payload);
      resetCache(User.id, props.userId);
      resetCache(UserView.id, props.userId);
      setNewEmailAddress(null);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, "An error occurred while changing the member's email address");
    }
  };
  return (
    <InputGroup>
      <InputGroup.Text>New Email Address</InputGroup.Text>
      <Editable
        handleChange={setNewEmailAddress}
        handleBlur={setNewEmailAddress}
        value={newEmailAddress}
        field={{
          seq: 0,
          type: FieldType.Text,
          label: 'Email address',
        }}
      />
      <Button size="sm" variant="danger" disabled={!isValid} onClick={handleClick}>
        Change
      </Button>
    </InputGroup>
  );
};
